import moment from 'moment'

// Find number of weeks for a given year.
// Can be either 52 or 53
export function weeksInYear(year) {
  return Math.max(
    moment(new Date(year, 11, 31)).isoWeek(), // eslint-disable-line no-magic-numbers
    moment(new Date(year, 11, 31 - 7)).isoWeek(), // eslint-disable-line no-magic-numbers
  )
}

// Returns a collection of dates between start and stop.
// Arguments provided must be of the type moment
export function momentRange(start, end) {
  let current = start.clone()
  const days = []
  while (current <= end) {
    days.push(current.clone())
    current = current.add(1, 'days')
  }

  return days
}
